import React from 'react';
import { PropTypes } from 'prop-types';
import InfoPanelFilters from './InfoPanelFilters';

var InfoPanel = function InfoPanel(_ref) {
  var filters = _ref.filters,
      panelContent = _ref.panelContent,
      onClick = _ref.onClick,
      onCancel = _ref.onCancel,
      onAccept = _ref.onAccept,
      selectedFilterButtonName = _ref.selectedFilterButtonName,
      applyButtonText = _ref.applyButtonText;
  return /*#__PURE__*/React.createElement("div", {
    className: "datepicker__infoPanel"
  }, filters.length > 0 && /*#__PURE__*/React.createElement(InfoPanelFilters, {
    filters: filters,
    onClick: onClick,
    onCancel: onCancel,
    onAccept: onAccept,
    selectedFilterButtonName: selectedFilterButtonName,
    applyButtonText: applyButtonText
  }), panelContent);
};

InfoPanel.propTypes = {
  filters: PropTypes.array,
  panelContent: PropTypes.any,
  onClick: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  selectedFilterButtonName: PropTypes.string,
  applyButtonText: PropTypes.string
};
InfoPanel.defaultProps = {
  selectedFilterButtonName: ''
};
InfoPanel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InfoPanel",
  "props": {
    "selectedFilterButtonName": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "filters": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "panelContent": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onCancel": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "onAccept": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "applyButtonText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default InfoPanel;